import e, { useState as d, useRef as y, useEffect as g } from "react";
import { Badge as f } from "../../../Badge/Badge.js";
import { calculateInnerElements as H } from "../../utils/calculateInnerElements.js";
import { getInnerElementsSizes as I } from "../../utils/getInnerElementsSizes.js";
const S = _ref => {
  let {
    children: a,
    width: E,
    headBadge: t,
    showHiddenBadgesCounter: _ = !0,
    hiddenBadgesColor: p = "info",
    fixedHeightElements: x
  } = _ref;
  var o;
  const l = ((o = a == null ? void 0 : a.length) != null ? o : 0) + (t ? 1 : 0),
    [s, b] = d(!0),
    r = y(null),
    [m, h] = d(l),
    [i, N] = d([]),
    B = m - 1,
    n = l - m;
  if (g(() => {
    b(!1), N(I(r));
  }, []), g(() => {
    h(H(i, r, 40));
  }, [i, E]), !a && !t) return x ? e.createElement("span", {
    className: "olx-ad-card__badges-items--fixed"
  }) : null;
  const v = _ && l > 0 && n > 0 && n !== l && !s;
  return e.createElement("ul", {
    className: "olx-ad-card__badges-items",
    ref: r,
    "data-loading": s,
    "data-testid": "badgeGroup"
  }, t && e.createElement("li", {
    className: "olx-ad-card__badges-item"
  }, t), a == null ? void 0 : a.map((c, C) => {
    const u = C + (t ? 1 : 0);
    if (!(u <= B)) return null;
    const w = typeof c == "string" ? f : e.Fragment;
    return e.createElement("li", {
      className: "olx-ad-card__badges-item",
      key: u
    }, e.createElement(w, null, c));
  }), v && e.createElement("li", {
    className: "olx-ad-card__badges-item"
  }, e.createElement(f, {
    "aria-label": "Mais de 1 item",
    color: p
  }, "+", n)));
};
export { S as Badges };